package link.erpango.quip.domain.ocr

/**
 * Pure text assembly for OCR results that are pasted into the note field.
 *
 * Kept free of Compose and platform types so the merge rule (separator + length limit) can be
 * unit tested from commonTest.
 */
object OcrNoteText {
    /** Separator inserted between the existing note and the recognized text. */
    const val SEPARATOR: String = "\n---\n"

    /**
     * Appends [recognized] to [existing], separated by [SEPARATOR], and clamps the result to
     * [limit] characters. Blank pieces are ignored: with an empty note the recognized text is
     * used as is, and with empty recognition the existing note is returned untouched.
     */
    fun merge(existing: String, recognized: String, limit: Int): String {
        if (limit <= 0) return ""
        val addition = recognized.trim()
        val base = existing.trimEnd()
        if (addition.isEmpty()) return base.take(limit)
        if (base.isEmpty()) return addition.take(limit)
        return (base + SEPARATOR + addition).take(limit)
    }
}
